import { useApp } from 'app';
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useCenterInfo from 'hooks/useCenterInfo';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import FormSignUp from './FormSignUp';
import './styles.scss';
import useAxios from 'axios-hooks';
import { notification } from 'utils/notification';

const InviteSignUpContext = createContext({});

InviteSignUpContext.displayName = 'InviteSignUpContext';

export const useInviteSignUp = () => {
  const context = useContext(InviteSignUpContext);
  return context;
};

const InviteSignUp = () => {
  const { t }: any = useDictionary({});
  const { themePro }: any = useApp();
  const { centerName } = useCenterInfo();
  const [modeView, setModeView] = useState({
    type: 'InviteSignUp',
  });
  const [inviteToken, setInviteToken] = useState('');
  const [inviteUser, setInviteUser] = useState('');

  const [{ loading }, fetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window?.location?.search);
    const tokenFromUrl = searchParams?.get('token') || '';
    setInviteToken(tokenFromUrl);
    // const langFromUrl = searchParams?.get('lang') || LANG_DEFAULT;
  }, []);

  useEffect(() => {
    if (!inviteToken) return;
    const getDataUserInvite = async () => {
      const res = await fetchData({
        // baseURL: 'http://localhost:8083',
        // url: '/get-data-user-invite',
        // headers: { [TENANT_HEADER_NAME]: 'sme-devs' },
        url: '/user/get-data-user-invite',
        method: 'GET',
        params: { inviteToken: inviteToken },
      });
      if (res?.data?.status === '200') {
        setInviteUser(res?.data?.data || null);
      } else {
        notification({ res });
      }
    };
    getDataUserInvite();
  }, [inviteToken]);

  const value: any = { t, centerName, inviteToken, inviteUser };

  const renderContent = () => {
    switch (modeView?.type) {
      case 'InviteSignUp':
        return <FormSignUp />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <InviteSignUpContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <div className="sign-up">
          <LoadPanel visible={loading} />
          <div className="content">
            {themePro && <div className="smdc">{centerName}</div>}
            {renderContent()}
          </div>
        </div>
      </React.Suspense>
    </InviteSignUpContext.Provider>
  );
};

export default InviteSignUp;
